import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SidebarContext } from "context/SidebarContext";
import HourRentalPeriodicHikeTimeServices from "services/HourRentalPeriodicHikeTimeServices";
import { notifyError, notifySuccess } from "utils/toast";

const useHourRentalPeriodicHikeTimeSubmit = (id) => {
  const { isDrawerOpen, closeDrawer, setIsUpdate } = useContext(SidebarContext);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedCity, setSelectedCity] = useState([]);
  const [dataInput, setDataInput] = useState([]);
  const [open, setOpen] = useState(false);
  console.log("selectedCity", selectedCity);
  const [startTimeOptions, setStartTimeOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const generateTimeOptions = () => {
    const options = [];
    const minutes = ["00", "30"];
    const periods = ["AM", "PM"];

    for (let period of periods) {
      for (let hour = 0; hour <= 11; hour++) {
        for (let minute of minutes) {
          options.push(`${hour === 0 ? 12 : hour}:${minute} ${period}`);
        }
      }
    }

    return options;
  };

  useEffect(() => {
    const options = generateTimeOptions();
    setStartTimeOptions(options);
    setDataInput((prevData) => [
      ...prevData,
      {
        [`start_time_${prevData.length}`]: "12:00 AM",
        [`end_time_${prevData.length}`]: "12:30 AM",
        ["vehicle_type_" + prevData.length]: [],
        ["hike_" + prevData.length]: "",
        ["endTimeOptions_" + prevData.length]: options.slice(1),
      },
    ]);
  }, []);

  useEffect(() => {}, [dataInput]);
  const handleStartTimeChange = (e, i, oldindex) => {
    const { value } = e.target;
    setDataInput((prevDataInput) => {
      return prevDataInput.map((row, index) => {
        if (index === oldindex) {
          const startTimeIndex = startTimeOptions.findIndex(
            (option) => option === value,
          );
          const endTimeOptionsForThisRow = startTimeOptions.slice(
            startTimeIndex + 1,
          ); // Start from next option
          return {
            ...row,
            [`start_time_${i}`]: value,
            [`end_time_${i}`]: endTimeOptionsForThisRow[0],
            [`endTimeOptions_${i}`]: endTimeOptionsForThisRow,
          };
        }
        return row;
      });
    });
  };

  const handleEndTimeChange = (e, i, oldindex) => {
    const { value } = e.target;
    setDataInput((prevDataInput) => {
      return prevDataInput.map((row, index) => {
        if (index === oldindex) {
          return { ...row, [`end_time_${i}`]: value };
        }
        return row;
      });
    });
  };

  const {
    trigger,
    register,
    handleSubmit,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm();

  const handleCityChange = (city_id) => {
    setSelectedCity(() => [...city_id]);
  };
  const handleChangeInput = (e, i, names = false) => {
    if (e && e.target) {
      const { name, value } = e.target;
      if (value === "0") {
        return;
      }
      const onChangeVal = [...dataInput];
      onChangeVal[i][name] = value;
      setDataInput(onChangeVal);
    } else {
      const onChangeVal = [...dataInput];
      onChangeVal[i][names] = e;
      setDataInput(onChangeVal);
    }
  };
  const handleVehicleCategoryChange = (selectedCity, i, name) => {
    // Update the input field
    handleChangeInput(selectedCity, i, name);
  };

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const hasDuplicateTimes = () => {
        const seenTimes = new Set();

        const convertToMinutes = (time) => {
          const [hourMinute, period] = time.split(" ");
          let [hour, minute] = hourMinute.split(":").map(Number);
          if (period === "PM" && hour !== 12) hour += 12;
          if (period === "AM" && hour === 12) hour = 0;
          return hour * 60 + minute;
        };

        for (const slot of dataInput) {
          const keys = Object.keys(slot).filter((key) =>
            key.startsWith("start_time_"),
          );

          for (const key of keys) {
            const start_time = slot[key];
            const end_time = slot[key.replace("start_time", "end_time")];
            const vehicle_key = key.replace("start_time", "vehicle_type");
            const vehicle_type = slot[vehicle_key]?.[0]?.value;

            const startMinutes = convertToMinutes(start_time);
            const endMinutes = convertToMinutes(end_time);

            for (const seenSlot of seenTimes) {
              const { seenStart, seenEnd, seenVehicleType } = seenSlot;

              if (
                vehicle_type === seenVehicleType &&
                ((startMinutes >= seenStart && startMinutes < seenEnd) ||
                  (endMinutes > seenStart && endMinutes <= seenEnd) ||
                  (startMinutes <= seenStart && endMinutes >= seenEnd))
              ) {
                return true;
              }
            }

            seenTimes.add({
              seenStart: startMinutes,
              seenEnd: endMinutes,
              seenVehicleType: vehicle_type,
            });
          }
        }

        return false;
      };
      if (hasDuplicateTimes()) {
        // Show error message
        setOpen(true);
        // console.error('Error: Duplicate start and end times found');
        return;
      }
      //console.log(dataInput);
      // return false;
      const startTimeArray = [];
      const endTimeArray = [];
      const hikeArray = [];
      const vehicleTypeArray = [];

      dataInput.forEach((val, i) => {
        Object.keys(val).forEach((key) => {
          if (key.startsWith("start_time_")) {
            const index = key.substring("start_time_".length);
            const endTimeKey = `end_time_${index}`;
            const hikeKey = `hike_${index}`;
            const vehicleArrKey = `vehicle_type_${index}`;
            if (val.hasOwnProperty(endTimeKey)) {
              const startTime = val[key];
              const endTime = val[endTimeKey];
              const Hike = val[hikeKey];
              const VehicleArr = val[vehicleArrKey];
              const VehicleSingleArr = [];
              VehicleArr.forEach((item) => {
                VehicleSingleArr.push(item.value);
              });
              vehicleTypeArray.push(VehicleSingleArr);
              startTimeArray.push(startTime);
              hikeArray.push(Hike);
              endTimeArray.push(endTime);
            }
          }
        });
      });

      const dataValues = {};
      // const cityIds = selectedCity.map((state) => {
      //   if (typeof state === 'string') {
      //     return state;
      //   }
      //   if (typeof state === 'object' && state.value) {
      //     return state.value;
      //   }
      //   return null;
      // }).filter(Boolean);
      // const cityIds=[];
      // selectedCity.forEach((dataInput)=>{
      //     cityIds.push(dataInput.value);
      //   });

      const cityIds = selectedCity.map(String);

      dataValues.vehicle_type = vehicleTypeArray;
      dataValues.hike = hikeArray;
      dataValues.start_time = startTimeArray;
      dataValues.end_time = endTimeArray;
      // dataValues.city=cityIds.sort((a, b) => a - b);
      dataValues.city = cityIds;
      if (cityIds.length === 0) {
        notifyError("City is required");
        return;
      }
      setIsSubmitting(true);

      if (id) {
        const res =
          await HourRentalPeriodicHikeTimeServices.updateHourRentalPeriodicHikeTime(
            id,
            dataValues,
          );
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
      } else {
        const res =
          await HourRentalPeriodicHikeTimeServices.addHourRentalPeriodicHikeTime(
            dataValues,
          );
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
      }
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
      setIsSubmitting(false);
      //  closeDrawer();
    } finally {
      setLoading(false);
    }
  };

  const getHourRentalPeriodicHikeTimeData = async () => {
    try {
      const res =
        await HourRentalPeriodicHikeTimeServices.getHourRentalPeriodicHikeTimeById(
          id,
        );
      //console.log(res);
      if (res) {
        const FormWholeArray = [];
        if (res[0].start_time) {
          res[0].start_time.forEach((item, index) => {
            let obj = {};
            const startTimeIndexEdit = startTimeOptions.findIndex(
              (option) => option === item,
            );
            const endTimeOptionsForThisRowEdit = startTimeOptions.slice(
              startTimeIndexEdit + 1,
            ); // Start from next option
            obj["endTimeOptions_" + index] = endTimeOptionsForThisRowEdit;
            obj["start_time_" + index] = item;
            obj["end_time_" + index] = res[index]["end_time"][index];

            const vehicleTypeNamesArray =
              res[index].vehicle_type_names.split(", ");
            const vehicle_type = res[index].vehicle_type.map((id, i) => ({
              value: Number(id),
              label: vehicleTypeNamesArray[i],
            }));
            obj["vehicle_type_" + index] = vehicle_type;

            obj["hike_" + index] = res[index]["hike"];
            FormWholeArray.push(obj);
          });
        }
        // const cities=res[0].city.map((id,index)=>({
        //   value:Number(id),
        //   label:res[0].city_names[index]

        // }));
        setDataInput(FormWholeArray);

        setSelectedCity(res[0].city);
      }
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
    }
  };

  useEffect(() => {
    if (!isDrawerOpen) {
      setSelectedCity([]);
      // setDataInput([
      //   {
      //     [`start_time_0`]: '12:00 AM',
      //     [`end_time_0`]: '12:30 AM',
      //     ['vehicle_type_0']: [],
      //     ['hike_0']: "",
      //     ['endTimeOptions_0']: generateTimeOptions().slice(1)
      //   }
      // ]);
      setDataInput([
        {
          start_time_0: "12:00 AM",
          end_time_0: "12:30 AM",
          vehicle_type_0: [],
          hike_0: "",
          endTimeOptions_0: generateTimeOptions().slice(1),
        },
      ]);
      clearErrors("city");
      clearErrors();

      return;
    }

    if (id) {
      getHourRentalPeriodicHikeTimeData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, setValue, isDrawerOpen, clearErrors]);

  return {
    register,
    handleSubmit,
    onSubmit,
    handleCityChange,
    selectedCity,
    setSelectedCity,
    trigger,
    errors,
    isSubmitting,
    setDataInput,
    dataInput,
    loading,
    setLoading,
    handleChangeInput,
    handleVehicleCategoryChange,
    handleEndTimeChange,
    handleStartTimeChange,
    startTimeOptions,
    setOpen,
    open,
  };
};

export default useHourRentalPeriodicHikeTimeSubmit;
